import Process from "../Process/Process";

import { getProgress } from "./loadingProgress";
import LoadingScreen from "./LoadingScreen";
import Bluescreen from "./Bluescreen";

import { CancellationError } from "engine/Runtime/cancellation";

import { extensions } from "pixi.js";
import { loadTextures } from "@pixi/assets";
import { loadTexturesUsingImageSource } from "./extensions/loadTexturesUsingImageSource";
import { loadPyxel } from "./extensions/loadPyxel";

extensions.remove(loadTextures);
if(module.hot) {
	// HMR of BaseTextures requires them to use Image for their source
	extensions.add(loadTexturesUsingImageSource);
} else {
	// Otherwise still has to be removed and added because of plugin order...
	extensions.add(loadTextures);
}
extensions.add(loadPyxel);

export default class Game extends Process<void> {
	
	private stage: Process<any> | null = null;
	private promise: Promise<{ default: new() => Process<any> }> | null;

	private hasError = false;
	
	constructor(promise: Promise<{ default: new() => Process<any> }>) {
		
		super();
		this.promise = promise;
		
		window.addEventListener('error', error => {
			this.switchToBluescreen(error, false);
		});

		window.addEventListener('unhandledrejection', e => {
			// https://bugzilla.mozilla.org/show_bug.cgi?id=1642147
			e.preventDefault();
			if(!(e.reason instanceof CancellationError)) {
				this.switchToBluescreen(e.reason, true);
			}
		});
		
	}
	
	protected async run() {
		try {
			// treat javascript files as one module
			window.dispatchEvent(new Event('moduleRequested'));
			this.promise!.then(() => {
				window.dispatchEvent(new Event('moduleLoaded'));
			});

			await this.createProcess(LoadingScreen, document.body, this.promise!, getProgress).getPromise();

			let { default: Main } = await this.promise!;
			this.promise = null;
			
			this.stage = this.createProcess(Main);
			await this.stage.getPromise();
			
		} catch(error) {
			this.switchToBluescreen(error, true);
			await new Promise(() => {});
		}
	}
	
	public frame() {
		
	}
	
	private async switchToBluescreen(error, persistent) {
		if(this.hasError) {
			return;
		}
		this.hasError = true;

		if(__DEV__ && !persistent) {
			if(this.stage) {
				this.stage.pause(true);
			}
		} else {
			if(this.stage) {
				this.stage.destroy();
			}
		}
		const domElements = Array.from(document.body.children);
		for(let child of domElements) {
			document.body.removeChild(child);
		}
		
		await this.createProcess(Bluescreen, document.body, error, persistent).getPromise();
		
		if(__DEV__) {
			this.hasError = false;
			for(let child of domElements) {
				document.body.appendChild(child);
			}
			if(this.stage) {
				this.stage.resume();
			}
		}
	}
	
}